import Vue from 'vue';
import Vuex from 'vuex';

import Login from './login/login'; //登录
import Home from './home/home'; //主业
import Performance from './report/performance'; //业绩统计

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
      //测试
      // urlHttp:'//47.104.190.180:6081', //网址
      // urlHttps:'//47.104.190.180:8081/develop', //网址
      // urlPay:'//47.104.190.180:8081/develop/xxpay', //支付
      // urlImg:'//47.104.190.180:6081', //图片
      // urlUpload:'//47.104.190.180:6081', //上传
      //正式
      urlHttp:'http://corp.hixiaoxiao.com', //网址
      urlHttps:'http://m.hixiaoxiao.com/v2', //网址
      urlPay:'http://m.hixiaoxiao.com/v2/xxpay', //支付
      urlImg:'http://img.hixiaoxiao.com',  //图片
      urlUpload:'http://upfile.hixiaoxiao.com',  //上传
      //build
      // urlHttp:'', //网址
      // urlHttps:'//m.hixiaoxiao.com/v2', //网址
      // urlPay:'//m.hixiaoxiao.com/v2/xxpay', //支付
      // urlImg:'//img.hixiaoxiao.com', //图片
      // urlUpload:'//upfile.hixiaoxiao.com', //上传

      urlNotice:'http://corp.hixiaoxiao.com', //公告
    },
    modules: {
      Login, //登录
      Home, //主页
      Performance, //业绩统计
    }
})

export default store;



// WEBPACK FOOTER //
// ./src/vuex/index.js